import { types } from './crudDinamico.actions'
import { Reducer } from '../../services/reducer.factory'
import { buildColumnFor } from './column-registry'
import storage from '../../services/stoage.service'
import utils from '../../utils'

const initialState = {
  id: 'crudDinamico',
  booleanFilter: {},
  chave: null,
  definicao: null,
  showHideColumns: [],
  columns: [],
  currentRecord: {},
  messages: null,
  selectedRecords: [],
  selectedFilters: [],
  usaListDto: true,
}

const reducer = new Reducer(initialState, types)

export function CRUDCrudDinamicoReducer(state, action) {
  if (state) {
    // labels genéricos do toolbar (label.novo, label.colunas...) + escopo crudDinamico do dicionário;
    // exige "crudDinamico" na lista de telas do PhoenixLoginService.getAppLabels (BE)
    state.messages = storage.getAppLabels('crudDinamico')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.RESET:
      return reset(state)
    case types.SET_DEFINICAO:
      return setDefinicao(state, action)
    case types.MAKE_NEW:
      // o MAKE_NEW do factory zera o record ({}); reaplica o template da definição com defaults
      return { ...state, currentRecord: novoRecordPadrao(state.definicao) }
    default:
      return state
  }
}

// boolean nunca fica sem valor: false por padrão, e a coluna "ativo" (convenção do
// sistema) começa marcada no registro novo
function novoRecordPadrao(definicao) {
  return ((definicao && definicao.campos) || []).reduce((record, campo) => {
    if (campo.tipo === 'boolean') {
      record[campo.nome] = campo.nome === 'ativo'
    } else {
      record[campo.nome] = ''
      if (campo.tipo === 'lookup') {
        record[`${campo.nome}__descricao`] = ''
      }
    }
    return record
  }, {})
}

function reset(state) {
  return {
    ...state,
    chave: null,
    definicao: null,
    showHideColumns: [],
    columns: [],
    currentRecord: {},
    records: [],
    selectedRecords: [],
    selectedFilters: [],
    sortField: '',
    sortOrder: 0,
  }
}

function setDefinicao(state, action) {
  const { chave, definicao } = action.payload
  const camposListagem = (definicao.campos || []).filter((campo) => campo.listagem)

  const columns = [
    // coluna de seleção múltipla (exclusão em massa) — desligável na definição via "selecaoMultipla": false
    ...(definicao.selecaoMultipla === false
      ? []
      : [
          {
            field: 'multiselect',
            header: utils.getMessage(state.messages, 'crudDinamico.label.selecao') || 'Seleção',
            columnKey: 'multiselect',
            visible: true,
          },
        ]),
    {
      field: 'oid',
      header: utils.getMessage(state.messages, 'crudDinamico.label.codigo') || 'Código',
      columnKey: 'oid',
      sortable: true,
      filter: true,
      columnSortField: 'oid',
      visible: true,
    },
    ...camposListagem.map(buildColumnFor),
  ]

  const showHideColumns = columns.map((column) => ({
    label: column.header,
    value: column,
  }))

  const currentRecord = novoRecordPadrao(definicao)

  return {
    ...state,
    chave,
    definicao,
    columns,
    showHideColumns,
    currentRecord,
  }
}
